import { useLocation } from "react-router-dom";
import { useEffect, useMemo, useRef, useState } from "react";
import { Button, Card, Col, Grid, Modal, Row, Spin, Tooltip } from "antd";
import {
  PieChartGraph,
  GanttChart,
  ConditionalRenderer,
  VisualizeWrapper,
  HeightVariantTileWrapper,
} from "components";

import {
  calculateFixHeight,
  checkForNotRequired,
  getGridStyles,
  getHighlightsTilesData,
  getLaunchTilesData,
  getMaxHeightForImage,
  getSummarydata,
  transformTimelineDataToChartData,
} from "./helpers";

import {
  getVideoRatio,
  getVideoRatio1,
  getVideoRatioDynamic,
} from "components/visualize-wrapper/helpers";
import { LineChartOutlined, PieChartOutlined } from "@ant-design/icons";
import { ReactComponent as NotRequired } from "icons/not-required.svg";

import {
  base64ImageArrayForAtheltics,
  base64ImageArrayForRest,
  timeChartKeysObj,
} from "./constants";
import { usePreviewHistoryApi } from "./usePreviewHistoryApi";
import styles from "./styles.module.scss";
import { CriticalImages } from "components/preview-history-multi/critical-images";
import { LayoutIcon, ModalCloseIcon } from "icons";
import { useRecoilState } from "recoil";
import { DTLvideoFramesImages, videoFramesImages } from "store/atom";
import { ChartV2 } from "pages/history/listing/components/processing-timeline-v2/chart";
import { ImagesCarousel } from "components/preview-history-multi/images-carousel";
import { ImagesActionHeader } from "components/preview-history-multi/images-action-header";
import { getVideoHeight } from "utils/helpers";

const { useBreakpoint } = Grid;

export function Preview({
  fileId,
  visible,
  swingType,
  sportName,
  givenPathName,
  extractionProgress,
  overallTimeLine,
  timeLineApiData,
  videoData,
}: any) {
  let { pathname } = useLocation();
  const localPathname = useLocation().pathname;
  const screens = useBreakpoint();
  pathname =
    pathname === "/m2c-analytics" || pathname?.includes("golf-facility-detail")
      ? "/m2c-golf-history"
      : pathname;

  // const [activeValue, setActiveValue] = useState<string>("Pose");
  const [activeComponent, setActiveComponent] = useState<any>("pieChart");
  const [imageData, setImageData] = useState<any>(
    pathname === "/m2c-athletics-history"
      ? base64ImageArrayForAtheltics
      : base64ImageArrayForRest,
  );

  // const containerHeightFix: any = screens.xl
  //   ? "calc(100dvh - 340px)"
  //   : window.innerHeight > 600
  //     ? "52dvh"
  //     : "70dvh";

  const containerHeightFix: any = calculateFixHeight({ screens });

  const [heightOfContainer, setHeightOfContainer] =
    useState(containerHeightFix);
  const [widthOfContainer, setWidthOfContainer] = useState<any>();
  const [expandCriticalImages, setExpandCriticalImages] = useState(false);
  const [faceonAllImagesRecoil, setFaceonAllImagesRecoil] =
    useRecoilState(videoFramesImages);
  const [DTLallImagesRecoil, setDTLaLLImagesRecoil] =
    useRecoilState(DTLvideoFramesImages);
  const [imagesCarousel, setImagesCarousel] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  const visualizeContainerRef = useRef<any>();
  const visualizeSmallContainerRef = useRef<any>();

  const {
    videoDetails,
    videoDetailsDataLoading,
    PValueImages,
    PValueImagesLoading,
    tracerImageData,
    tracerImageLoading,
  }: any = usePreviewHistoryApi({ pathname, fileId, sportName });

  const isM2cAnalytics = localPathname === "/m2c-analytics";

  const containerHeight = visualizeContainerRef?.current?.clientHeight;
  const smallImageContainerHeight =
    visualizeSmallContainerRef?.current?.clientHeight;

  const summaryData = getSummarydata(videoDetails?.data);
  const {
    lh_extrinsic_score,
    lh_overall_score,
    rh_extrinsic_score,
    rh_overall_score,
  } = videoDetails?.data?.calib_score || {};

  const { videoHeight, videoWidth } = getDimesionsFromResolution(
    summaryData?.resolution,
  );

  const containerWidth: any = getVideoRatio(containerHeight);

  const maxAllowedWidth = parseInt(
    (isM2cAnalytics ? widthOfContainer : containerWidth)?.replace("px", ""),
  );
  const maxAllowedSmallWidth = 181;

  // Adjust containerHeight dynamically to ensure width does not exceed 400px
  let adjustedHeight = containerHeight;
  const predictedWidth = (containerHeight * videoWidth) / videoHeight;

  if (predictedWidth > maxAllowedWidth) {
    adjustedHeight = (maxAllowedWidth * videoHeight) / videoWidth;
  }

  const containerWidthDynamic = getVideoRatioDynamic({
    height: adjustedHeight,
    videoHeight,
    videoWidth,
  });
  const containerWidthDynamic1 = getVideoRatio1({
    height: adjustedHeight,
    videoHeight,
    videoWidth,
  });

  let adjustedSmallHeight = smallImageContainerHeight;
  const predictedSmallWidth =
    (smallImageContainerHeight * videoHeight) / videoWidth;

  if (predictedSmallWidth > maxAllowedSmallWidth) {
    adjustedSmallHeight = (maxAllowedSmallWidth * videoWidth) / videoHeight;
  }

  const containerSmallWidthDynamic = getVideoRatioDynamic({
    height: adjustedSmallHeight,
    videoHeight,
    videoWidth,
  });
  const finalImages = useMemo(
    () =>
      imageData?.filter((image: any) =>
        Object.values(image)?.some((value) => value !== null),
      ),
    [imageData],
  );

  function onClickImage(imageName: any) {
    const index = finalImages?.findIndex(
      (item: any) => Object.keys(item)[0] === imageName,
    );

    setExpandCriticalImages(true);
    setImagesCarousel(true);
    setImageIndex(index);
  }

  function handleResizeWidth() {
    setWidthOfContainer(
      getVideoRatio(visualizeContainerRef?.current?.clientHeight),
    );
  }

  // function handleResize() {
  //   setHeightOfContainer(containerHeightFix);
  // }
  useEffect(() => {
    if (visualizeContainerRef?.current) {
      setWidthOfContainer(
        getVideoRatio(visualizeContainerRef?.current?.clientHeight),
      );
    }
  }, []);

  // useEffect(() => {
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);
  useEffect(() => {
    window.addEventListener("resize", handleResizeWidth);
    return () => window.removeEventListener("resize", handleResizeWidth);
  }, []);

  const P7 = "P7";

  const initialImageDataForLaunch = [];
  const range = 4; // Number of keys to generate on each side of P7

  for (let i = -range; i <= range; i++) {
    if (i === 0) {
      initialImageDataForLaunch.push({ [P7]: "" });
    } else {
      const key = `${P7} ${i < 0 ? "-" : "+"} ${Math.abs(i)}`;
      initialImageDataForLaunch.push({ [key]: "" });
    }
  }
  initialImageDataForLaunch.push({ "P5 + 5": "" });

  useEffect(() => {
    if (PValueImages && videoDetails) {
      const imageData = convertUrlsToBase64({
        images: PValueImages?.images,
        data: videoDetails.data,
      });

      setImageData(imageData);
    }
  }, [PValueImages, videoDetails]);

  useEffect(() => {
    if (!videoHeight || !videoWidth) return;

    function updateHeight() {
      const { width, height } =
        visualizeContainerRef.current?.getBoundingClientRect() || {};
      if (!screens.xxl) {
        const heightCal = getVideoHeight({
          width: Math.round(width || 0 / 2), //
          height,
          videoHeight,
          videoWidth,
        });

        setHeightOfContainer(heightCal);
      } else {
        setHeightOfContainer(containerHeightFix);
        setWidthOfContainer(
          getVideoRatio(visualizeContainerRef?.current?.clientHeight),
        );
      }
    }
    updateHeight();

    window.addEventListener("resize", updateHeight);
  }, [screens, videoHeight, videoWidth]);

  function urlToBase64(url: any) {
    return `data:image/jpeg;base64,${url}`;
  }

  function convertUrlsToBase64({ images, data }: any) {
    const base64ImageArray: any = [];
    let keysToCheck: any = [];

    if (
      pathname === "/m2c-launch-history" ||
      pathname === "/m2c-golf-history" ||
      (pathname === "/user-history" && sportName === "Golf")
    ) {
      if (PValueImages.status === false) {
        keysToCheck = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
      } else if (
        pathname === "/m2c-golf-history" ||
        (pathname === "/user-history" && sportName === "Golf")
      ) {
        keysToCheck = [
          "P1",
          "P2",
          "P3",
          "P4",
          "P5",
          "P6",
          "P7",
          "P8",
          "P9",
          "P10",
        ];
      } else {
        keysToCheck = [
          "P7 - 4",
          "P7 - 3",
          "P7 - 2",
          "P7 - 1",
          "P7",
          "P7 + 1",
          "P7 + 2",
          "P7 + 3",
          "P7 + 4",
          "P7 + 5",
        ];
      }
    } else if (
      pathname === "/m2c-athletics-history" ||
      sportName === "Athletics"
    ) {
      keysToCheck = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
    } else {
      if (data?.orientation === "FaceOn" && data?.swingType === "full swing") {
        keysToCheck = [
          "P1",
          "P2",
          "P3",
          "P4",
          "P5",
          "P6",
          "P7",
          "P8",
          "P9",
          "P10",
        ];
      } else if (
        data?.orientation === "FaceOn" &&
        data?.swingType !== "full swing" &&
        data?.swingType !== "Scan"
      ) {
        keysToCheck = ["P1", "P4", "P7", "P10"];
      } else if (
        data?.orientation === "DownTheLine" &&
        data?.swingType === "full swing"
      ) {
        keysToCheck = ["P1", "P2", "P3", "P4", "P5", "P6", "P7", "P10"];
      } else if (
        data?.orientation === "DownTheLine" &&
        data?.swingType !== "full swing" &&
        data?.swingType !== "Scan"
      ) {
        keysToCheck = ["P1", "P4", "P7", "P10"];
      } else if (data?.swingType === "Scan") {
        keysToCheck = [];
      }
    }

    // Iterate over each key-value pair in the input data object

    keysToCheck.forEach((key: any) => {
      const url = images[key];
      if (url) {
        const base64Data = urlToBase64(url);
        base64ImageArray.push({ [key]: base64Data });
      } else {
        base64ImageArray.push({ [key]: null }); // Add null for missing URLs
      }
    });

    return base64ImageArray;
  }

  const chartData = transformTimelineDataToChartData(
    timeLineApiData,
    "pose-preview",
  );

  let requiredChartData =
    chartData &&
    chartData?.filter((state: any) => {
      return timeChartKeysObj[pathname]?.includes(state?.name);
    });

  if (
    (pathname === "/m2c-golf-history" || pathname === "/user-history") &&
    activeComponent === "pieChart"
  ) {
    const dataToHide: any = [];
    // const dataToHide = ["Pose Processing Time", "Club Processing Time"];
    requiredChartData =
      chartData &&
      requiredChartData?.filter((state: any) => {
        return !!!dataToHide.includes(state?.name);
      });
  }

  const launchTilesData = getLaunchTilesData(
    videoDetails?.club_launch_data?.ball,
    videoDetails?.club_launch_data?.club,
  );
  const hightlightsTilesData = getHighlightsTilesData(videoDetails?.highlights);
  const tracerImage = tracerImageData ? urlToBase64(tracerImageData) : null;

  const isDisplayHeighlightTiles =
    (pathname === "/m2c-golf-history" || sportName !== "Athletics") &&
    swingType !== "Scan";

  const isDisplayLaunchTiles =
    (pathname === "/m2c-golf-history" ||
      pathname === "/m2c-launch-history" ||
      sportName !== "Athletics") &&
    swingType !== "Scan";

  function getDimesionsFromResolution(resolution: any): any {
    if (resolution) {
      const arr = resolution.split("x");
      const videoHeight = parseInt(arr[0]);
      const videoWidth = parseInt(arr[1]);
      return { videoHeight, videoWidth };
    }
  }

  const calibrationItems = [
    {
      imageSrc: "/assets/icons/rhExtrinsicScoreIcon.svg",
      propertyName: "Rh Extrinsic score:",
      propertyValue: rh_extrinsic_score,
    },
    {
      imageSrc: "/assets/icons/rhOverallScoreIcon.svg",
      propertyName: "Rh Overall score:",
      propertyValue: rh_overall_score,
    },
    {
      imageSrc: "/assets/icons/lhExtrinsicScoreIcon.svg",
      propertyName: "Lh Extrinsic score:",
      propertyValue: lh_extrinsic_score,
    },
    {
      imageSrc: "/assets/icons/lhOverallScoreIcon.svg",
      propertyName: "Lh Overall score:",
      propertyValue: lh_overall_score,
    },
  ];

  const containerStyle: React.CSSProperties =
    screens.lg && !screens.xxl
      ? {
          display: "flex",
          flexDirection: "column",
          minHeight: "90dvh",
          // justifyContent: "space-between",
          gap: "20px",
        }
      : {};

  return (
    <div
      style={{
        width: "100%",
        ...containerStyle,
      }}
    >
      <Row>
        <Col
          span={6}
          xs={24}
          sm={24}
          md={16}
          lg={10}
          xl={7}
          xxl={6}
          style={{ padding: "2px" }}
        >
          <Spin spinning={videoDetailsDataLoading}>
            <Card
              bordered={true}
              className={styles["serverCard"]}
              styles={{
                body: {
                  padding: "5px",
                  minHeight: screens.xxl ? "258px" : "200px",
                  maxHeight: screens.xxl ? "258px" : "200px",
                },
              }}
            >
              <div className={styles["cardTitleContent"]}>
                <div className={styles["iconContainer"]}>
                  <h4 className={styles["cardTitle"]}>Summary</h4>
                </div>
                <ConditionalRenderer
                  condition={pathname !== "/m2c-athletics-history"}
                >
                  <div className={styles["statusButton"]}>
                    <div className={styles["statusIndicator"]}>
                      <img
                        src="/assets/icons/coach.svg"
                        alt="Icon 1"
                        style={{ marginRight: "1px", height: "18px" }}
                      />
                      {summaryData.role}
                    </div>
                  </div>
                </ConditionalRenderer>
              </div>

              <div
                className={styles["cardMiddleSection"]}
                style={{
                  backgroundColor: "#EBF8ED",
                  marginTop: "1px",
                  minWidth: "200px",
                }}
              >
                <PropertyContainer1
                  imageSrc={"/assets/icons/uploadedBy.svg"}
                  propertyName={"Uploaded By:"}
                  propertyValue={summaryData?.uploadedBy}
                  marginRight
                />

                <PropertyContainer1
                  imageSrc={"/assets/icons/fileName.svg"}
                  propertyName={"Video Name:"}
                  propertyValue={summaryData.videoName}
                  marginRight
                />
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "5px",
                  justifyContent: "space-between",
                }}
              >
                <div
                  className={styles["cardMiddleSection"]}
                  style={{
                    backgroundColor: "rgba(0, 185, 244, 0.1)",
                    marginTop: "1px",
                    width:
                      pathname === "/m2c-athletics-history" ? "100%" : "47%",
                    height: screens.xxl
                      ? "calc(258px - 70px)"
                      : "calc(200px - 70px)",
                    maxHeight: "166px",
                    overflow: "auto",
                  }}
                >
                  <PropertyContainer1
                    imageSrc={"/assets/icons/deviceType.svg"}
                    propertyName={"Device Type:"}
                    propertyValue={summaryData?.deviceType}
                  />
                  <PropertyContainer1
                    imageSrc={"/assets/icons/deviceModel.png"}
                    propertyName={"Device Model:"}
                    propertyValue={summaryData?.mobileModel}
                  />
                  {/* <PropertyContainer1
                    imageSrc={"/assets/icons/versionNumberIcon.png"}
                    propertyName={"Version Number: "}
                    propertyValue={summaryData?.appVersion}
                  /> */}

                  <ConditionalRenderer
                    condition={summaryData.swingType !== "Scan"}
                  >
                    <PropertyContainer1
                      imageSrc={"/assets/icons/camera.svg"}
                      propertyName={"Camera:"}
                      propertyValue={summaryData?.camera}
                    />

                    <PropertyContainer1
                      imageSrc={"/assets/icons/deviceAngle.svg"}
                      propertyName={"Device Angle:"}
                      propertyValue={summaryData?.deviceAngle}
                    />

                    <PropertyContainer1
                      imageSrc={"/assets/icons/iso.svg"}
                      propertyName={"ISO:"}
                      propertyValue={summaryData?.ISO}
                    />

                    <PropertyContainer1
                      imageSrc={"/assets/icons/shutter.svg"}
                      propertyName={"Shutter:"}
                      propertyValue={summaryData?.shutter}
                    />
                  </ConditionalRenderer>

                  <PropertyContainer1
                    imageSrc={"/assets/icons/duration.svg"}
                    propertyName={"Duration:"}
                    propertyValue={summaryData?.duration + " " + "sec"}
                  />

                  <PropertyContainer1
                    imageSrc={"/assets/icons/fps.svg"}
                    propertyName={"Frame Rate:"}
                    propertyValue={Number(summaryData?.frameRate)?.toFixed(2)}
                  />

                  <PropertyContainer1
                    imageSrc={"/assets/icons/resolution.svg"}
                    propertyName={"Resolution:"}
                    propertyValue={summaryData?.resolution}
                  />

                  <PropertyContainer1
                    imageSrc={"/assets/icons/triggerType.svg"}
                    propertyName={"isCameraMoved:"}
                    propertyValue={summaryData?.isCameraMoved}
                    marginRight
                  />
                </div>

                <ConditionalRenderer
                  condition={pathname !== "/m2c-athletics-history"}
                >
                  <div style={{ width: "50%" }}>
                    <div
                      className={styles["cardMiddleSection"]}
                      style={{
                        backgroundColor: "#F0F0F0",
                        marginTop: "1px",
                        // height: "98%",
                        maxHeight: "166px",
                        height: screens.xxl
                          ? "calc(258px - 70px)"
                          : "calc(200px - 70px)",
                      }}
                    >
                      <PropertyContainer1
                        imageSrc={"/assets/icons/swingType.svg"}
                        propertyName={"Swing Type:"}
                        propertyValue={summaryData.swingType}
                        marginRight
                      />

                      <PropertyContainer1
                        imageSrc={"/assets/icons/orientation.svg"}
                        propertyName={"Orientation:"}
                        propertyValue={summaryData?.orientation}
                        marginRight
                      />

                      <ConditionalRenderer
                        condition={summaryData.swingType !== "Scan"}
                      >
                        <PropertyContainer1
                          imageSrc={"/assets/icons/handedNess.svg"}
                          propertyName={"Handedness:"}
                          propertyValue={summaryData?.handedness}
                          marginRight
                        />

                        <PropertyContainer1
                          imageSrc={"/assets/icons/clubType.svg"}
                          propertyName={"Club Type:"}
                          propertyValue={summaryData?.clubType}
                          marginRight
                        />

                        <PropertyContainer1
                          imageSrc={"/assets/icons/triggerType.svg"}
                          propertyName={"Trigger Type:"}
                          propertyValue={summaryData?.triggertype}
                          marginRight
                        />
                        {/* {calibrationItems?.map((item) => (
                          <PropertyContainer1
                            key={item.imageSrc}
                            imageSrc={item.imageSrc}
                            propertyName={item.propertyName}
                            propertyValue={item.propertyValue}
                            marginRight
                          />
                        ))} */}
                      </ConditionalRenderer>
                    </div>
                  </div>
                </ConditionalRenderer>
              </div>
            </Card>
          </Spin>
        </Col>
        <ConditionalRenderer condition={isDisplayHeighlightTiles}>
          <Col
            span={4}
            sm={24}
            xs={24}
            md={8}
            lg={7}
            xl={5}
            xxl={4}
            style={{ padding: "2px" }}
          >
            <Spin spinning={videoDetailsDataLoading}>
              <Card
                className={styles.basicCardContainer}
                styles={{
                  body: {
                    padding: "5px",
                    minHeight: screens.xxl ? "262px" : "200px",
                    maxHeight: screens.xxl ? "262px" : "200px",
                  },
                }}
              >
                <h1 className={styles.basicCardHeading}>Highlights</h1>
                <div className={styles["basicCardData"]}>
                  {hightlightsTilesData?.map((item: any, index: any) => (
                    <HeightVariantTileWrapper
                      key={index}
                      title={item.title}
                      unit={item.unit}
                      value={item.value}
                      variant={item.variant}
                      clubFittingFirstColumn
                      isFirstColumn={index % 3 === 0 ? true : false}
                    />
                  ))}
                </div>
              </Card>
            </Spin>
          </Col>
        </ConditionalRenderer>

        <ConditionalRenderer condition={isDisplayLaunchTiles}>
          <Col
            span={4}
            sm={24}
            xs={24}
            md={8}
            lg={7}
            xl={5}
            xxl={4}
            style={{ padding: "2px" }}
          >
            <Spin spinning={videoDetailsDataLoading}>
              <Card
                className={styles.basicCardContainer}
                styles={{
                  body: {
                    padding: "5px",
                    minHeight: screens.xxl ? "262px" : "200px",
                    maxHeight: screens.xxl ? "262px" : "200px",
                  },
                }}
              >
                <h1 className={styles.basicCardHeading}>Launch Values</h1>
                <div className={styles["basicCardData"]}>
                  {launchTilesData?.map((item: any, index: any) => (
                    <HeightVariantTileWrapper
                      key={index}
                      title={item.title}
                      unit={item.unit}
                      value={item.value}
                      variant={item.variant}
                      clubFittingFirstColumn
                    />
                  ))}
                </div>
              </Card>
            </Spin>
          </Col>
        </ConditionalRenderer>
        <Col
          span={7}
          sm={24}
          xs={24}
          md={16}
          lg={24}
          xl={7}
          xxl={7}
          style={{ padding: "2px" }}
        >
          <Spin spinning={videoDetailsDataLoading}>
            <Card
              style={{ height: "100%" }}
              styles={{
                body: {
                  padding: "5px",
                  minHeight: screens.xxl ? "262px" : "200px",
                  maxHeight: screens.xxl ? "262px" : "200px",
                },
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h1 className={styles.remarksTitle}>Time Chart</h1>

                <div>
                  <Button
                    onClick={() => setActiveComponent("pieChart")}
                    type={
                      activeComponent === "pieChart" ? "primary" : "default"
                    }
                    icon={<PieChartOutlined />}
                    style={{
                      marginBottom: "8px",
                      marginRight: "5px",
                      height: "30px",
                      backgroundColor:
                        activeComponent === "pieChart" ? "#006AB3" : "white",
                      borderColor:
                        activeComponent === "pieChart" ? "#006AB3" : "grey",
                    }}
                    className={styles.button}
                  />

                  <Button
                    onClick={() => setActiveComponent("gantt")}
                    type={activeComponent === "gantt" ? "primary" : "default"}
                    icon={<LineChartOutlined />}
                    style={{
                      marginBottom: "8px",
                      height: "30px",
                      backgroundColor:
                        activeComponent === "gantt" ? "#006AB3" : "white",
                      borderColor:
                        activeComponent === "gantt" ? "#006AB3" : "grey",
                    }}
                    className={styles.button}
                  />
                </div>
              </div>
              <div className={styles.chartContainer}>
                {chartData && (
                  <>
                    <ConditionalRenderer
                      condition={activeComponent === "pieChart"}
                    >
                      <PieChartGraph
                        chartData={requiredChartData}
                        type="preview"
                      />
                    </ConditionalRenderer>

                    <ConditionalRenderer
                      condition={activeComponent === "gantt"}
                    >
                      <ChartV2
                        series={overallTimeLine?.series}
                        chartMin={overallTimeLine?.min}
                        chartMax={overallTimeLine?.max}
                        height={screens?.xxl ? 220 : 170}
                        barHeight={screens.xxl ? 22 : 17}
                        separateBars={true}
                        hideLegends
                      />
                      {/* <GanttChart
                        timeLineData={requiredChartData}
                        type="preview"
                      /> */}
                    </ConditionalRenderer>
                  </>
                )}
              </div>
            </Card>
          </Spin>
        </Col>

        <Col
          span={3}
          sm={24}
          xs={24}
          md={3}
          lg={0}
          xxl={3}
          style={{ padding: "2px" }}
        >
          <Card
            style={{ height: "100%" }}
            styles={{ body: { padding: "5px" } }}
          >
            <h1 className={styles.remarksTitle}></h1>
            <div className={styles.remarksContainer}></div>
          </Card>
        </Col>
      </Row>

      <div
        className={styles.videoAndImages}
        style={{
          display: "grid",
          gridTemplateColumns: getGridStyles(
            screens,
            isM2cAnalytics ? widthOfContainer : containerWidth,
          ),
          gap: "20px",
          alignItems: "center",
        }}
      >
        <div
          style={{
            position: "relative",
            maxWidth: isM2cAnalytics ? widthOfContainer : containerWidth,
            borderRadius: "6px",
            overflow: "hidden",
          }}
          id="video-container"
        >
          <VisualizeWrapper
            fileId={fileId}
            visible={visible}
            deviceType={summaryData?.deviceType}
            extractionProgress={extractionProgress}
            frames={faceonAllImagesRecoil}
            videoHeight={videoHeight}
            videoWidth={videoWidth}
          />
        </div>
        <Spin spinning={tracerImageLoading}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "black",
              // width: containerWidthDynamic1,
              maxWidth: isM2cAnalytics ? widthOfContainer : containerWidth,
              width: widthOfContainer,
              height: heightOfContainer,
            }}
            className={styles.visualizeWrapperContainer}
            ref={visualizeContainerRef}
          >
            <img
              src={tracerImage as any} // Access the base64 data from the object value
              width={isM2cAnalytics ? widthOfContainer : widthOfContainer}
              alt=""
              style={{
                // borderRadius: "5px",
                backgroundColor: "#f0f0f0", // Set background color or use backgroundImage: `url(${imageUrl})` for actual images
                height: `${adjustedHeight}px`,
              }}
            />
          </div>
        </Spin>
        <Spin
          spinning={PValueImagesLoading}
          wrapperClassName={styles.imagesWrapper}
        >
          <ImagesActionHeader
            expandCriticalImages={expandCriticalImages}
            isDesktop={false}
            setExpandCriticalImages={setExpandCriticalImages}
            setImageIndex={setImageIndex}
            setImagesCarousel={setImagesCarousel}
            showLayoutChangeIcon={false}
          />
          <CriticalImages
            PValueImages={PValueImages}
            swingType={swingType}
            videoHeight={videoHeight}
            videoWidth={videoWidth}
            ExpandImages={false}
            imageData={imageData}
            setExpandCriticalImages={setExpandCriticalImages}
            isDesktop={false}
            videoData={videoData}
            loading={PValueImagesLoading}
            onClickImage={onClickImage}
          />
        </Spin>
      </div>
      <Modal
        closeIcon={<ModalCloseIcon />}
        open={expandCriticalImages}
        onCancel={() => setExpandCriticalImages(false)}
        footer={null}
        style={{
          width: "97vw", // Set width to 100vw
          maxWidth: "100%", // Ensure the modal doesn't overflow
          // height: "95dvh",
          // top: 5,
        }}
        centered
        styles={{
          body: {
            height: "98dvh",
          },
          content: {
            padding: "8px 20px",
          },
        }}
        width="97VW"
        destroyOnClose={true}
      >
        <ImagesActionHeader
          expandCriticalImages={expandCriticalImages}
          isDesktop={false}
          setExpandCriticalImages={setExpandCriticalImages}
          setImageIndex={setImageIndex}
          setImagesCarousel={setImagesCarousel}
          showLayoutChangeIcon
        />
        <div style={{ height: "94dvh" }}>
          <ConditionalRenderer condition={!imagesCarousel}>
            <CriticalImages
              PValueImages={PValueImages}
              swingType={swingType}
              videoHeight={videoHeight}
              videoWidth={videoWidth}
              imageData={imageData}
              setExpandCriticalImages={setExpandCriticalImages}
              ExpandImages
              isDesktop={false}
              videoData={videoData}
              loading={PValueImagesLoading}
              onClickImage={onClickImage}
            />
          </ConditionalRenderer>
          <ConditionalRenderer condition={imagesCarousel}>
            <ImagesCarousel
              videoHeight={videoHeight}
              videoWidth={videoWidth}
              imageData={imageData}
              imageIndex={imageIndex}
              positions={videoDetails?.club_position}
            />
          </ConditionalRenderer>
        </div>
      </Modal>
    </div>
  );
}

function PropertyContainer1({
  imageSrc,
  propertyName,
  propertyValue,
  marginRight = false,
}: any) {
  return (
    <div className={styles["entry"]}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "flex" }}>
          <img
            src={`${imageSrc}`}
            alt={`${propertyName}-icon`}
            className={styles["entryIcon"]}
          />
        </div>
        <div
          style={{ marginRight: marginRight ? "10px" : "0px" }}
          className={styles.propertyName}
        >
          <h4 className={styles["entrySubheading"]}>{propertyName}</h4>
        </div>
      </div>
      <div>
        <span className={styles["entryValue"]}>{propertyValue || "--"}</span>
      </div>
    </div>
  );
}
